import '/Users/yannbraga/Dev/yann-blog/node_modules/@chromaui/addon-visual-tests/dist/manager.mjs';